import httpClient from "@/services/httpClient";

export const alumni_getProfile = () => {
  return httpClient.get("api/alumni/alumni_student/alumni_getProfile");
};

export const alumni_getData = (data) => {
  return httpClient.post("api/alumni/alumni_student/alumni_getData", data);
};
export const alumni_updateData = (data) => {
  return httpClient.post("api/alumni/alumni_student/alumni_updateData", data);
};
